import React, { useState } from 'react';
import Login from './components/Login';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  const handleLoginSuccess = (userData) => {
    setIsAuthenticated(true);
    setUserInfo(userData);

    const adminDashboardUrl = (process.env.REACT_APP_ADMIN_DASHBOARD_URL || '/admin').replace(/\/$/, '');
    const agentDashboardUrl = (process.env.REACT_APP_AGENT_DASHBOARD_URL || '/agent').replace(/\/$/, '');
    
    // Redirect to appropriate dashboard based on user type
    const agentName = encodeURIComponent(userData.agent_name || '');
    const designation = encodeURIComponent(userData.designation || '');
    if (userData.user_type === 'admin_cx' || userData.user_type === 'admin_px') {
      window.location.href = `${adminDashboardUrl}?agent_name=${agentName}&designation=${designation}`;
    } else if (userData.user_type === 'agent_cx' || userData.user_type === 'agent_px') {
      window.location.href = `${agentDashboardUrl}?agent_name=${agentName}`;
    } else {
      window.location.href = `${agentDashboardUrl}?agent_name=${agentName}`;
    }
  };


  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserInfo(null);
    localStorage.removeItem('auth_token');
  };

  return (
    <div className="App">
      {!isAuthenticated ? (
        <Login onLoginSuccess={handleLoginSuccess} />
      ) : (
        <div className="dashboard-redirect">
          <div className="loading-container">
            <div className="spinner"></div>
            <h2>Redirecting to your dashboard...</h2>
            <p>Welcome, {userInfo?.full_name || userInfo?.phone_number}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
